import { useEffect, useState, useRef } from 'react';
import { Radio, theme } from 'antd';
import * as echarts from 'echarts/core';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { LineChart, PieChart } from 'echarts/charts';
import { UniversalTransition, LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { withCartesianAxisTheme, withSeriesLabelTheme, withTooltipTheme } from '../../chartEchartsTheme';
import './index.less';

echarts.use([GridComponent, LineChart, UniversalTransition, TooltipComponent, LegendComponent, PieChart, CanvasRenderer, LabelLayout]);

const ChartsView = ({ data, type }) => {
    const { token } = theme.useToken();
    const viewRef = useRef();
    const chartRef = useRef();

    const [curType, setCurType] = useState();

    const onBtnChange = e => {
        setCurType(e.target.value);
    };

    const formatOptions = (chartData, chartToken) => {
        const xData = chartData.map(item => item.content);
        const valData = chartData.map(item => item.num);
        let options = {
            xAxis: withCartesianAxisTheme(
                {
                    type: 'category',
                    data: xData,
                    axisLabel: {
                        rotate: 30,
                        interval: 0,
                        margin: 4,
                        formatter: value => {
                            if (value.length > 13) value = value.slice(0, 13) + '...';
                            var ret = '\n\n';
                            var maxLength = 8;
                            var valLength = value.length;
                            var rowN = Math.ceil(valLength / maxLength);
                            if (rowN > 1) {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = '';
                                    var start = i * maxLength;
                                    var end = start + maxLength;
                                    temp = value.substring(start, end) + '\n';
                                    ret += temp;
                                }
                                return ret;
                            } else {
                                return value;
                            }
                        },
                    },
                },
                chartToken,
            ),
            tooltip: withTooltipTheme(
                {
                    trigger: 'axis',
                    className: 'tooltip_text_wrap',
                },
                chartToken,
            ),
            yAxis: withCartesianAxisTheme(
                {
                    type: 'value',
                    min: (value, index) => {
                        if (value.min < 1) {
                            return 0;
                        } else {
                            return value.min;
                        }
                    },
                    max: (value, index) => {
                        if (value.max < 5) {
                            return 5;
                        } else {
                            return value.max;
                        }
                    },
                    minInterval: 1,
                    axisLabel: {
                        formatter: (value, index) => {
                            return value;
                        },
                    },
                },
                chartToken,
            ),
            series: withSeriesLabelTheme(
                [
                    {
                        data: valData,
                        type: 'bar',
                        barWidth: '20',
                        barCategoryGap: '20%',
                        label: {
                            show: true,
                            position: 'top',
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                    },
                ],
                chartToken,
            ),
        };
        if (chartData.length > 10) {
            options = {
                ...options,
                dataZoom: {
                    type: 'slider',
                    show: true,
                    startValue: 0,
                    endValue: 10,
                    height: 10,
                    bottom: 0,
                    showDetail: false,
                    showDataShadow: false,
                    fillerColor: chartToken.colorFillSecondary,
                    zoomLock: true,
                    brushSelect: false,
                    handleStyle: {
                        opacity: 0,
                    },
                    lineStyle: {
                        marginTop: '10px',
                        opacity: 0,
                    },
                    textStyle: {
                        fontSize: 0,
                    },
                },
            };
        }
        return options;
    };

    const resizeHandler = () => {
        chartRef.current.resize();
    };

    useEffect(() => {
        setTimeout(() => {
            // 创建一个echarts实例，返回echarts实例。不能在单个容器中创建多个echarts实例
            chartRef.current = echarts.init(viewRef.current);
            setCurType('2');
            window.addEventListener('resize', resizeHandler);
        }, 0);
        // 组件卸载
        return () => {
            // myChart.dispose() 销毁实例。实例销毁后无法再被使用
            chartRef.current.dispose();
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    useEffect(() => {
        if (!chartRef.current) return;
        const op = formatOptions(data, token);
        chartRef.current.clear();
        chartRef.current.setOption(op);
    }, [curType, data, token]);

    return (
        <div className="chart_view_wrap">
            <Radio.Group value={curType} onChange={onBtnChange}>
                <Radio.Button value="2">柱状图</Radio.Button>
            </Radio.Group>
            <div ref={viewRef} className="chart_view"></div>
        </div>
    );
};

export default ChartsView;
